import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Label = styled.div`
  display: inline-block;
  position: relative;

  ${({ theme }) => `
    padding: 6px ${theme.space.mobile.small};
    background: ${theme.color.oceanLight};
    line-height: 1.2;
    border-radius: ${theme.borderRadius.base};

    &:after {
      content: '';
      position: absolute;
      left: 1px;
      top: 100%;
      width: 0;
      height: 0;
      border-top: 6px solid ${theme.color.oceanDark};
      border-left: 11px solid transparent;
    }
  `}

  ${({ theme }) => media.sm`
    max-width: 100%;
    padding: 8px ${theme.space.mobile.small};

    & > div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  `}
`
